import React, { useState } from 'react';
import { Box, Divider, TextField, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import BackdropDialog from 'common/components/BackdropDialog';
import { useSelector } from 'react-redux';
import * as RentalViewSelectors from 'selectors/RentalViewSelectors';
import { useTranslation } from 'services/localization';

interface Props {
	onEdit: (value: string) => void;
	onCancel: () => void;
	open: boolean;
	label: string;
	value: string | undefined;
}
const BookingCommentModal = (props: Props) => {
	const classes = useStyles();
	const { t, getTranslation } = useTranslation();
	const { onEdit, onCancel, open, label, value } = props;
	const [editedValue, setEditedValue] = useState(value ?? '');
	const rentalInfo = useSelector(RentalViewSelectors.orderInfo)!;
	const bookingComment = rentalInfo.bookingComment;

	const handleSaveComment = () => {
		onEdit(editedValue);
	};

	return (
		<BackdropDialog
			isOpen={open}
			onClose={onCancel}
			label={label}
			body={
				<>
					{!!bookingComment?.value?.length && (
						<>
							<Box mb={4}>
								<Typography className={classes.customerCommentLabel} variant="body1">
									{getTranslation(bookingComment?.label ?? { def: t('common:form.comment') })}
								</Typography>
								<Typography className={classes.customerComment} variant="body1">
									{bookingComment?.value}
								</Typography>
							</Box>
							<Divider />
						</>
					)}
					<Box mb={4} />
					<TextField
						label={t('shopperInfo.staffComment', 'Staff comment')}
						multiline
						rows={3}
						maxRows={5}
						value={editedValue}
						variant={'outlined'}
						onChange={(e) => setEditedValue(e.target.value)}
						className={classes.textField}
						InputLabelProps={{ shrink: true }}
					/>
				</>
			}
			width="xs"
			confirm={{
				label: t('common:actions.save'),
				callback: handleSaveComment,
				closeAfterDone: true,
			}}
			cancel={{
				label: t('common:actions.cancel'),
				autoFocus: false,
			}}
		/>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		textField: {
			width: '100%',
		},
		customerComment: {
			marginBottom: theme.spacing(1),
		},
		customerCommentLabel: {
			marginBottom: theme.spacing(1),
			fontWeight: 500,
		},
	}),
);

export default BookingCommentModal;
